<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  minLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Hotel Blocking Update",
      items: [
        {
          text: "Hotel Blocking",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      agents: [],
      admins: [],
      roles: [],
      uuid: "",
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
      form: {
          hotel_name: "",
          is_search_blocked: "",
          is_booking_blocked: "",
          destination: "",
          country_code: "",
          user_id: "",
          user_account_type:"",
          user_group_id: "",
          is_active: "",
      },
      submitform: false,
      submitted: false,
    };
  },
    validations: {
        form: {
            is_allowed: {
                required,
            },
            is_booking_blocked: {
                required,
            },
            is_search_blocked: {
                required,
            },
            is_active: {
                required,
            },
            user_group_id: {
                required,
                numeric,
            },
            user_account_type:{
                required,
            },
            user_id: {
                required,
            },
            destination: {
                required,
                minLength: minLength(3),
            },
            country_code: {
                required,
                minLength: minLength(2),
            },
        },
    },

  created() {
    this.uuid = this.$route.params.uuid;
  },
  mounted() {
    this.getRoleList();
    this.getAdminList();
    this.blockDetail();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          let nullArr=[];
                          nullArr.value=null;
                          nullArr.text='all';
                          arr.push(nullArr);
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      getUserOnChange(event) {
          var _that = this;
          try {
              axios
                  .get("/api/user/type", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                          type: this.rolelist[event.target.value],
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          let nullArr=[];
                          nullArr.value=null;
                          nullArr.text='all';
                          arr.push(nullArr);
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _that.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async blockDetail() {
      try {
        axios
          .post("/api/hotel/block_detail/" + this.uuid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
                this.form.hotel_name=data.hotel_name,
                    this.form.is_search_blocked=data.is_search_blocked,
                    this.form.is_booking_blocked=data.is_booking_blocked,
                    this.form.destination=data.destination,
                    this.form.country_code=data.country_code,
                    this.form.user_account_type=data.user_account_type,
                    this.form.user_id=data.user_id,
                    this.form.user_group_id=data.user_group_id,
                    this.form.is_active=data.is_active
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      getRoleListOnChange(event) {
          var _that = this;
          try {
              axios
                  .get("/api/role/type", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                          type: event.target.value,
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          _that.roles = response.data.data;
                          _that.rolelist = [];
                          response.data.data.map(function(value, key) {
                              _that.rolelist[value.id] = value.type;
                          });
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _that.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },

      formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/hotel/block_update", {
          uuid: this.uuid,
            hotel_name:this.form.hotel_name,
            is_search_blocked: this.form.is_search_blocked,
            is_booking_blocked: this.form.is_booking_blocked,
            destination: this.form.destination,
            country_code: this.form.country_code,
            user_id: this.form.user_id,
            user_account_type: this.form.user_account_type,
            user_group_id:this.form.user_group_id,
            is_active: this.form.is_active,
            created_by: localStorage.getItem("uuid"),
            updated_by: localStorage.getItem("uuid"),
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.hotelblockingForm.reset();
            this.$swal("Good job!", "Hotel Block Updated", "success");
            this.$router.push({ name: "hotel_block_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
    <Layout>
        <flashMessage/>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="errors" class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="hotelblockingForm" @submit.prevent="formSubmit">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="hotel_name">Hotel Name</label>
                                        <input
                                            id="hotel_name"
                                            v-model="form.hotel_name"
                                            name="hotel_name"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Hotel Name"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.hotel_name.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.hotel_name.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.hotel_name.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="is_search_blocked">Search Block</label>
                                        <select
                                            id="is_search_blocked"
                                            name="is_search_blocked"
                                            v-model="form.is_search_blocked"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_search_blocked.$error }">
                                            <option value="" disabled style="display:none" selected>Select Search Block</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_search_blocked.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_search_blocked.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="is_booking_blocked">Booking Block</label>
                                        <select
                                            id="is_booking_blocked"
                                            name="is_booking_blocked"
                                            v-model="form.is_booking_blocked"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_booking_blocked.$error }">
                                            <option value="" disabled style="display:none" selected>Booking Block</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_booking_blocked.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_booking_blocked.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="destination">Destination</label>
                                        <input
                                            id="destination"
                                            v-model="form.destination"
                                            name="destination"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Destination "
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.destination.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.destination.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.destination.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="country_code">Country Code</label>
                                        <input
                                            id="country_code"
                                            v-model="form.country_code"
                                            name="country_code"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Country Code "
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.country_code.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.country_code.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.country_code.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="is_active">Active</label>
                                        <select
                                            id="is_active"
                                            name="is_active"
                                            v-model="form.is_active"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_active.$error }">
                                            <option value="" disabled style="display:none" selected>Select Active</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_active.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_active.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="account_type">User Type</label>
                                        <select
                                            id="account_type"
                                            name="account_type"
                                            v-model="form.user_account_type"
                                            class="form-control"
                                            v-on:change="getRoleListOnChange"
                                            placeholder="Type User type"
                                        >
                                            <option value="" disabled style="display:none" selected>Select User Type</option>
                                            <option value="null">All</option>
                                            <option value="b2b">B2B</option>
                                            <option value="b2c">B2C</option>
                                        </select>
                                        <!--     <div
                                              v-if="submitted && $v.form.agent_type.$error"
                                              class="invalid-feedback"
                                            >
                                              <span v-if="!$v.form.agent_type.required">This value is required.</span>
                                            </div> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="user_group_id.">Select Role</label>
                                        <select
                                            id="user_group_id."
                                            name="user_group_id."
                                            v-model="form.user_group_id"
                                            class="form-control"
                                            v-on:change="getUserOnChange"
                                            :class="{ 'is-invalid': submitted && $v.form.user_group_id.$error }">
                                            <option value="" disabled style="display:none" selected>Select Role</option>
                                            <option value="null">All</option>
                                            <option v-for="(role, index) in roles" :value="role.id"
                                                    v-bind:key="index" v-if="role.type!='admin'" :selected="form.user_role_id == role.id">{{ role.name}}
                                            </option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.user_group_id.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.user_group_id.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Select User</label>
                                        <model-select :options="admins"
                                                      v-model="form.user_id"
                                                      placeholder="Select User"
                                        >

                                        </model-select>
                                        <div
                                            v-if="submitted && $v.form.user_id.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.user_id.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </b-form>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
